export default __webpack_public_path__ + "static/media/cabourg23.51fdb44f.jpg";